import { Link, useNavigate } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuGroup, // Corrected import
} from '@/components/ui/dropdown-menu'
import { useAuthStore } from '@/stores/authStore'
import { NameAvatar } from './name-avatar'
import { useTranslation } from 'react-i18next'
import { LogOutIcon } from 'lucide-react'
import { ConfirmDialog } from './confirm-dialog'
import { useState } from 'react'
import { toast } from '@/hooks/use-toast'
import { logout } from '@/api/auth'
import { IconUserCog } from '@tabler/icons-react'

export function ProfileDropdown() {
  const { auth } = useAuthStore()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleLogout = async () => {
    setIsLoading(true)
    try {
      await logout()
      toast({ title: t('logout_successful') })
      navigate({ to: '/auth/login' })
    } catch {
      toast({ variant: 'destructive', title: t('logout_failed') })
    } finally {
      setIsLoading(false)
      setShowLogoutConfirm(false)
    }
  }

  return (
    <>
      <DropdownMenu modal={false} dir="rtl">
        <DropdownMenuTrigger asChild>
          <Button variant='ghost' className='relative h-8 w-8 rounded-full'>
            <NameAvatar
              name={auth.user?.name ?? ''}
              className="h-7 w-7"
            />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='w-56' align='end' forceMount>
          <DropdownMenuLabel className='font-normal'>
            <div className='flex flex-col space-y-1'>
              <p className='text-sm font-medium leading-none'>
                {auth.user?.name ?? ''}
              </p>
              <p className='text-xs leading-none text-muted-foreground'>
                {auth.user?.username ?? ''}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem asChild>
              <Link to='/profile'>
                <IconUserCog className="ml-2 h-4 w-4" />
                {t('account')}
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setShowLogoutConfirm(true)}>
            <LogOutIcon className="ml-2 h-4 w-4" />
            {t('logout')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ConfirmDialog
        open={showLogoutConfirm}
        onOpenChange={setShowLogoutConfirm}
        title={t('confirm_logout_title')}
        desc={t('confirm_logout_desc')}
        handleConfirm={handleLogout}
        confirmText={t('logout')}
        cancelBtnText={t('cancel')}
        destructive
        isLoading={isLoading}
      />
    </>
  )
}
